import { useAdvancedSearchUX } from 'features/knowledgeDocumentViewer/components/advancedSearch/contexts/AdvancedSearchUXContext'
import { PLACEHOLDER_MAP } from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/constants'
import React, { memo } from 'react'

import { AgenticSearchBox } from './AgenticSearchBox'
import { DocumentSearchModeToggle } from './DocumentSearchModeToggle'
import { SearchToolbar } from './SearchToolbar'
import { EdgeFade, SearchSection } from './unifiedSearchLandingStyles'

export const LandingSearchBar = memo(function LandingSearchBar() {
  const {
    searchInput,
    handleSearchChange,
    handleSearchKeyDown,
    handleSearchSubmit,
    contentFilter,
    searchMode,
    handleSearchModeChange,
    searchSuggestions,
    onSuggestionSelect,
    onClearSearchHistory,
    favoriteSearches,
    isSearchFavorited,
    toggleSearchFavorite,
  } = useAdvancedSearchUX()

  const isDocumentSearch = contentFilter === 'documents'
  const shouldShowSearchSuggestions =
    !isDocumentSearch || searchMode !== 'agentic'

  return (
    <SearchSection>
      {isDocumentSearch ? (
        <AgenticSearchBox
          searchInput={searchInput}
          onSearchChange={handleSearchChange}
          onSearchKeyDown={handleSearchKeyDown}
          onSearchSubmit={handleSearchSubmit}
          placeholder='Ask Anything or Search Documents...'
          suggestions={
            shouldShowSearchSuggestions ? searchSuggestions : undefined
          }
          onSuggestionSelect={onSuggestionSelect}
          onClearHistory={onClearSearchHistory}
          favoriteSearches={favoriteSearches}
          isSearchFavorited={isSearchFavorited}
          onToggleSearchFavorite={toggleSearchFavorite}
          contentFilter={contentFilter}
          rightContent={
            <DocumentSearchModeToggle
              searchMode={searchMode}
              onSearchModeChange={handleSearchModeChange}
            />
          }
        />
      ) : (
        <SearchToolbar
          variant='landing'
          searchInput={searchInput}
          onSearchChange={handleSearchChange}
          onSearchKeyDown={handleSearchKeyDown}
          onSearchSubmit={handleSearchSubmit}
          placeholder={PLACEHOLDER_MAP[contentFilter]}
          suggestions={searchSuggestions}
          onSuggestionSelect={onSuggestionSelect}
          onClearHistory={onClearSearchHistory}
          favoriteSearches={favoriteSearches}
          isSearchFavorited={isSearchFavorited}
          onToggleSearchFavorite={toggleSearchFavorite}
          contentFilter={contentFilter}
        />
      )}
      <EdgeFade $placement='below' aria-hidden />
    </SearchSection>
  )
})
